export enum SubstituteReason {
  OUT_OF_SERVICE = 'OutOfService',
  COULD_NOT_FIND = 'CouldNotFind',
  ALREADY_IN_DOOR = 'AlreadyInDoor',
  AS_REQUESTED = 'Requested',
}
